export const PartnersRedirect = () => {
  window.location.reload();
  return null;
};
